import { InjectionToken } from '@angular/core';

export const MCRAI_MODAL_DATA = new InjectionToken<any>('McRAIModalData');
